/**
 * Carousel Item
 */

import React from 'react';
import { Box, Typography, Button, ListItem, ListItemAvatar, ListItemText, Avatar } from '@mui/material';

interface CarouselItemProps {
    title: string;
    description: string;
    buttonText: string;
    author?: {
        name: string;
        avatar: string;
        caption?: string;
    }
}

const CarouselItem: React.FC<CarouselItemProps> = ({ title, description, buttonText, author }) => {
    return (
        <Box sx={{
            height: '100%',
            padding: 4
        }}>
            <Typography variant='h4' gutterBottom>{title}</Typography>
            <Typography variant='body1'>{description}</Typography>
            {
                author && (
                    <ListItem component={'span'} sx={{
                        mt: 5,
                        backgroundColor: 'rgba(0,0,0,0.2)',
                        borderRadius: 2,
                    }}>
                        <ListItemAvatar>
                            <Avatar src={author.avatar} />
                        </ListItemAvatar>
                        <ListItemText primary={author.name} secondary={author.caption ?? ''} secondaryTypographyProps={{
                            color: 'rgba(255,255,255,0.5)'
                        }}/>
                    </ListItem>
                )
            }
        </Box>
    );
};

export default CarouselItem;